export const GoogleTagManager = {
  FREE_WILL_CONVERSION_ID: 'AW-586201983',
  FREE_WILL_SIGNUP_CONVERSION: 'AW-586201983/w-X-CIaLysIDEP_2wpcC',
  FREE_WILL_COMPLETED_CONVERSION: 'AW-586201983/aNzICImLysIDEP_2wpcC',
  GTM_LINK: 'https://www.googletagmanager.com/gtm.js?id=',
  GTAG_LINK: 'https://www.googletagmanager.com/gtag/js?id=',
  GA_TRACKER_ID: 'GTM-K6MT224',
  HOTJAR_GTM_ID: 'GTM-NXHDLBK'
};
